import { queryOptions } from '@tanstack/react-query'
import taxAuthorityMessageApi from 'api/taxAuthorityMessageApi'
import _ from 'lodash'

export const queries = {
  base: {
    scope: ['taxMessage', 'listTaxMessageInvoice'],
    entity: 'taxMessageInvoice',
  },
  list: (params) => ({
    ...queries.base,
    params,
  }),
  lists: (params, systemType) =>
    queryOptions({
      staleTime: 1000 * 30,
      queryKey: [queries.list(params), systemType],
      queryFn: ({ signal }) => {
        switch (systemType) {
          case 'TNCN':
            return taxAuthorityMessageApi.listInvoiceMessageAccountingDocuments(
              {
                ...params,
                invoiceType: 'used',
              },
              signal,
            )

          default:
            return taxAuthorityMessageApi.listInvoiceMessage(
              {
                ...params,
                invoiceType: 'used',
              },
              signal,
            )
        }
      },
      select: (res) => ({
        total: _.get(res, 'count', 0),
        rows: !res?.rows
          ? []
          : _.map(res?.rows, (row, idx) => ({
              ...row,
              id: idx + 1,
            })),
      }),
    }),
}
